import React, { Component } from "react";
import moment from "moment";
import { Button, Col, Empty, Row, Table } from "antd";
import { connect } from "react-redux";
import { empty } from "../shared/helpers/generalHelper";
import { MOMENT_READABLE_DATETIME_FORMAT } from "../shared/utils/constants";

class InventoryTransferOutPrint extends Component {
    constructor(props) {
        super(props);

        let trx = null;
        try {
            trx = JSON.parse(localStorage.getItem("transferOutPrint"));
        } catch (e) {
            trx = null;
        }

        this.state = { trx };
    }

    render() {
        const { trx } = this.state;
        const { posConfig } = this.props;
        const columns = [
            {
                title: "Nama Barang",
                dataIndex: "item_name",
                key: "item_name"
            },
            {
                title: "Qty Saat Ini",
                dataIndex: "qty_now",
                key: "qty_now"
            },
            {
                title: "Qty Transfer",
                dataIndex: "qty",
                key: "qty"
            },
            {
                title: "Unit",
                dataIndex: "unit_name",
                key: "unit_name"
            }
        ];

        return (
            <Row>
                <Col>
                    <div style={{ padding: 10 }}>
                        <h1>Transfer Keluar</h1>
                        {empty(trx) && <Empty style={{ maxWidth: 500, margin: "100px 0" }} />}
                        {!empty(trx) && (
                            <React.Fragment>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>Outlet</td>
                                            <td style={{ width: 15, textAlign: "center" }}>:</td>
                                            <td>{posConfig.brand_name} - {posConfig.outlet_name}</td>
                                        </tr>
                                        <tr>
                                            <td>Kasir</td>
                                            <td style={{ width: 15, textAlign: "center" }}>:</td>
                                            <td>{posConfig.cashier_name}</td>
                                        </tr>
                                        <tr>
                                            <td>Transfer ID</td>
                                            <td style={{ width: 15, textAlign: "center" }}>:</td>
                                            <td>{trx.trx_id}</td>
                                        </tr>
                                        <tr>
                                            <td>Waktu Transfer</td>
                                            <td style={{ width: 15, textAlign: "center" }}>:</td>
                                            <td>{trx.trx_time ? moment(trx.trx_time).format("DD-MM-YYYY HH:mm") : ""}</td>
                                        </tr>
                                        <tr>
                                            <td>Lokasi Stok Asal</td>
                                            <td style={{ width: 15, textAlign: "center" }}>:</td>
                                            <td>{trx.source_location_name}</td>
                                        </tr>
                                        <tr>
                                            <td>Lokasi Stok Tujuan</td>
                                            <td style={{ width: 15, textAlign: "center" }}>:</td>
                                            <td>{trx.target_location_name}</td>
                                        </tr>
                                        <tr>
                                            <td>Catatan / Keterangan</td>
                                            <td style={{ width: 15, textAlign: "center" }}>:</td>
                                            <td>{trx.notes}</td>
                                        </tr>
                                        <tr>
                                            <td>Waktu Cetak</td>
                                            <td style={{ width: 15, textAlign: "center" }}>:</td>
                                            <td>{moment().format(MOMENT_READABLE_DATETIME_FORMAT)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div style={{ marginTop: 50 }}>
                                    <Table
                                        size="small"
                                        rowKey="inv_stock_trf_detail_id"
                                        columns={columns}
                                        dataSource={trx.inv_stock_trf_details || []}
                                        style={{ maxWidth: 800 }}
                                        pagination={false}
                                    />
                                    <div className="hideOnPrint" style={{ marginTop: 16, textAlign: "left" }}>
                                        <Button type="primary" onClick={() => window.print()}>Print</Button>
                                    </div>
                                </div>
                            </React.Fragment>
                        )}
                    </div>
                </Col>
            </Row>
        );
    }
}

const mapStateToProps = state => {
    return {
        posConfig: state.authState.userData
    };
};

export default connect(mapStateToProps)(InventoryTransferOutPrint);
